module.exports = __webpack_public_path__ + "assets/img/21_800.da1a4008.jpg";